import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { CKButton } from 'clearkit';

import Footer from '~/components/Footer';
import TextField from '~/components/RedesignedTextField';

import styles from './styles';
import UpgradePlanItem from './UpgradePlanItem';
import UpgradePlanSection from './UpgradePlanSection';

export const addonOptions = [
  'advertising',
  'conversion_tracking',
  'dynamic_content',
  'form_shortening',
  'google_analytics',
  'data_enrichment',
  'lead_management',
  'revenue_insights',
];

export function isValid(values) {
  const anyOptionSelected = addonOptions.some((i) => values[i]);

  if (values.other && !values.message) {
    return false;
  }

  return values.email !== '' && values.name !== '' && anyOptionSelected;
}

function RequestAccessForm({
  classes,
  values,
  onChange,
  onClose,
  valid,
  onSubmit,
}) {
  return (
    <form onSubmit={onSubmit} className={classes.formOuter}>
      <div className={classes.body}>
        <div className={classes.formInner}>
          <div className={classes.contactInfo}>
            <FormControl fullWidth className={classes.field}>
              <FormLabel>Email address*</FormLabel>
              <TextField
                onChange={(event) => onChange('email', event.target.value)}
                value={values.email}
              />
            </FormControl>

            <FormControl fullWidth className={classes.field}>
              <FormLabel>Name*</FormLabel>
              <TextField
                onChange={(event) => onChange('name', event.target.value)}
                value={values.name}
              />
            </FormControl>
          </div>

          <div className={classes.planOptions}>
            <p className="text-lg text-gray-600">
              Let us know what you're interested in
            </p>

            <UpgradePlanSection title="Create demand" addon="acquisitions">
              <UpgradePlanItem
                name="advertising"
                title="Precise B2B ad targeting"
                description="Reach more decision makers at target accounts"
                values={values}
                onChange={onChange}
                addon="acquisitions"
              />
              <UpgradePlanItem
                name="conversion_tracking"
                title="Enhance ad performance tracking"
                description="Train ads to convert qualified leads, without cookies"
                values={values}
                onChange={onChange}
                addon="acquisitions"
              />
            </UpgradePlanSection>

            <UpgradePlanSection title="Convert intent" addon="conversions">
              <UpgradePlanItem
                name="dynamic_content"
                title="Dynamic web content"
                description="Increase conversion with relevant experiences"
                values={values}
                onChange={onChange}
                addon="conversions"
              />
              <UpgradePlanItem
                name="form_shortening"
                title="Optimized site conversion"
                description="Shorten web forms without losing any leads data"
                values={values}
                onChange={onChange}
                addon="conversions"
              />
              <UpgradePlanItem
                name="google_analytics"
                title="Improve marketing attribution"
                description="Drive insights via Google Analytics"
                values={values}
                onChange={onChange}
                addon="conversions"
              />
            </UpgradePlanSection>

            <UpgradePlanSection title="Accelerate revenue" addons="operations">
              <UpgradePlanItem
                name="data_enrichment"
                title="Enriched accounts in CRM/MAP"
                description="Add accurate, fresh data to new & existing records"
                values={values}
                onChange={onChange}
                addons="operations"
              />
              <UpgradePlanItem
                name="lead_management"
                title="Error-free lead management"
                description="Score & route leads correctly the first time"
                values={values}
                onChange={onChange}
                addons="operations"
              />
              <UpgradePlanItem
                name="revenue_insights"
                title="Improved revenue insights"
                description="Drive insights with GTM, website and ICP reporting"
                values={values}
                onChange={onChange}
                addons="operations"
              />
            </UpgradePlanSection>

            <div className="mt-8">
              <UpgradePlanItem
                name="other"
                title="Other"
                values={values}
                onChange={onChange}
              />

              {values.other && (
                <div className="mt-4">
                  <FormControl fullWidth>
                    <FormLabel>Message</FormLabel>
                    <TextField
                      onChange={(event) =>
                        onChange('message', event.target.value)
                      }
                      placeholder="Let us know a little more about what you're aiming to accomplish and if you have any additional requirements."
                      value={values.message}
                      multiline
                      rows={3}
                      InputProps={{ rel: 'message' }}
                    />
                  </FormControl>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer
        right={
          <>
            <CKButton onClick={onClose}>Cancel</CKButton>
            <CKButton
              variant="bold"
              variantColor="blue"
              isDisabled={!valid}
              type="submit">
              Submit
            </CKButton>
          </>
        }
      />
    </form>
  );
}

RequestAccessForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func,
  valid: PropTypes.bool,
};

export default withStyles(styles)(RequestAccessForm);
